<div *ngIf="showLifeBridgeFinancialsBanner" class="top-banner-small">
    After you complete your application, please send a copy of last year’s tax return as well as your most
     recent pay stub to {{lifeBridgeSendDocumentToName}} ({{lifeBridgeSendDocumentToEmail}}). This information is needed to verify
     your income and that you are currently working. If you have any questions or need additional information,
     call MassMutual at 1-800-272-2216 or visit <a href="www.massmutual.com/lifebridge" class="top-banner-small__link">www.massmutual.com/lifebridge</a>.
</div>
<div class="account-center-banner">
    <loading *ngIf="isLoading"></loading>
    <div class="account-center-banner__content">
        <ng-container *ngFor="let title of bannerTitles">
            <div class="account-center-banner__title">
                {{title}}
            </div>
        </ng-container>

        <ng-container *ngFor="let subTitle of bannerSubTitles">
            <div class="account-center-banner__subtitle">
                {{subTitle}}
            </div>
        </ng-container>

        <div *ngIf="buttonText" class="account-center-banner__button-container">
            <div *ngIf="!loadingEsign; else esign" class="button button--primary button--yellow" (click)="onClickAction()">{{buttonText}}</div>
            <ng-template #esign><spinner color="white"></spinner></ng-template>
        </div>

        <ng-container
                *ngIf="action === 'TLIC Issued:Waiting for Labs' || action === 'Haven Application:Waiting for Labs'">
            <button class="button-link account-center-banner__button-link text-link--secondary"
                    (click)="openScheduleMedicalExamModal()">How do I schedule a medical exam?
            </button>
        </ng-container>

        <ng-container *ngIf="action === 'TLIC Issued:Final Underwriting' || action === 'Manual Underwriting:Final Review' || action === 'Application:Final Review' || action === 'Manual Underwriting:Awaiting APS'">
            <div class="account-center-banner__subtitle">
                How long does it take to review?
                <tooltip
                        [helpText]="'It usually takes 2-3 days but could be shorter or longer if additional requirements are needed.'">
                </tooltip>
            </div>
            <button class="button-link account-center-banner__button-link text-link--secondary"
                    (click)="resendEsignEmail()">Resend the eSign Email
            </button>
        </ng-container>

        <ng-container
                *ngIf="(action === 'Accelerated Application:Waiting for Signature' && !customerSignedApp) || action === 'TLIC Application:Waiting for Signature' || action === 'Haven Application:Waiting for Signature'">
            <button class="button-link account-center-banner__button-link text-link--secondary"
                    (click)="resendEsignEmail()">Resend the eSign Email
            </button>
        </ng-container>
    </div>
</div>
